
import { post, get, put, del, token, DEV_TOKEN } from './api.js';

/**
 * Create.
 */
export function create(id, comment) {

    let payload = {
        id: id,
        comment: comment
    };

    return post('contact/', payload, token || DEV_TOKEN);
}
